/* =========================================================================
   ws-perf/lazy-screens.ts — React.lazy wrappers for route-based code splitting.
   Workstream A: Performance & Code Splitting.
   ========================================================================= */

import React from "react";

// Wrap each screen module in a default export for React.lazy compatibility
export const LazyExecutiveSummary = React.lazy(() =>
  import("../screens-core").then((m) => ({ default: m.ExecutiveSummary })),
);
export const LazyOperatorEconomics = React.lazy(() =>
  import("../screens-core").then((m) => ({ default: m.OperatorEconomics })),
);
export const LazyDeveloperEconomics = React.lazy(() =>
  import("../screens-core").then((m) => ({ default: m.DeveloperEconomics })),
);
export const LazySensitivities = React.lazy(() =>
  import("../screens-analysis").then((m) => ({ default: m.Sensitivities })),
);
export const LazyBenchmarks = React.lazy(() =>
  import("../screens-analysis").then((m) => ({ default: m.Benchmarks })),
);
export const LazyModelChecks = React.lazy(() =>
  import("../screens-analysis").then((m) => ({ default: m.ModelChecks })),
);
export const LazyReport = React.lazy(() =>
  import("../screens-analysis").then((m) => ({ default: m.Report })),
);
export const LazyRiskAnalysis = React.lazy(() =>
  import("../screens-analysis").then((m) => ({ default: m.RiskAnalysis })),
);
export const LazyAssumptions = React.lazy(() =>
  import("../screens-config").then((m) => ({ default: m.Assumptions })),
);
export const LazyBuildings = React.lazy(() =>
  import("../screens-config").then((m) => ({ default: m.Buildings })),
);
export const LazyRentEconomics = React.lazy(() =>
  import("../screens-rent").then((m) => ({ default: m.RentEconomics })),
);
export const LazyBuilderQuotes = React.lazy(() =>
  import("../screens-quotes").then((m) => ({ default: m.BuilderQuotes })),
);
export const LazyComplianceDashboard = React.lazy(() =>
  import("../screens-compliance").then((m) => ({
    default: m.ComplianceDashboard,
  })),
);
export const LazyCompare = React.lazy(() =>
  import("../screens-compare").then((m) => ({ default: m.Compare })),
);
export const LazyVersions = React.lazy(() =>
  import("../screens-versions").then((m) => ({ default: m.Versions })),
);
export const LazySites = React.lazy(() =>
  import("../screens-sites").then((m) => ({ default: m.Sites })),
);

export const LazyFallback = () => (
  <div style={{ padding: 40, textAlign: "center" }}>
    <div
      className="skeleton"
      style={{ height: 24, width: 120, borderRadius: 6, margin: "0 auto 16px" }}
    />
    <div
      className="skeleton"
      style={{ height: 16, width: 200, borderRadius: 6, margin: "0 auto" }}
    />
  </div>
);
